import { Divider, Stack } from '@mui/material';
import { Provider } from '@repo/api-gw-sdk';

import { CustomAccountDisplayName } from '@/components/form/customAccountDisplayName';
import { FormTextField } from '@/components/form/formTextField';
import { getCloudFieldConfig } from '@/components/form/validation/cloudFieldValidation';

const accountIdConfig = getCloudFieldConfig(Provider.Aws, 'accountId');

export const AwsAccountConnectionFields = ({
  accountId,
  setAccountId,
  roleName,
  setRoleName,
  customName,
  setCustomName,
}: {
  accountId: string;
  setAccountId: (accountId: string) => void;
  roleName: string;
  setRoleName: (roleName: string) => void;
  customName: string;
  setCustomName: (customName: string) => void;
}) => {
  return (
    <Stack gap='40px' divider={<Divider sx={{ borderStyle: 'dashed' }} />}>
      <Stack gap='24px'>
        <FormTextField
          testId='account-id'
          title='AWS account ID'
          placeholder={accountIdConfig.placeholder}
          validation={accountIdConfig.validation}
          value={accountId}
          onChange={(event) => setAccountId(event.target.value)}
        />
        <CustomAccountDisplayName
          entityName='account'
          customName={customName}
          setCustomName={setCustomName}
        />
      </Stack>
      <FormTextField
        title='Eon role name'
        placeholder='Enter role name'
        value={roleName}
        onChange={(event) => setRoleName(event.target.value)}
      />
    </Stack>
  );
};
